import { render } from "./NewGames.vue?vue&type=template&id=3ffb91c0"
import script from "./NewGames.vue?vue&type=script&lang=js"
export * from "./NewGames.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__